module.exports = __webpack_public_path__ + "img/electricity.ffb223d6.png";